import { render } from "./CustomTa1.vue?vue&type=template&id=9d14f6e2&scoped=true"
import script from "./CustomTa1.vue?vue&type=script&lang=js"
export * from "./CustomTa1.vue?vue&type=script&lang=js"

import "./CustomTa1.vue?vue&type=style&index=0&id=9d14f6e2&scoped=true&lang=css"

import exportComponent from "/home/runner/work/corpsales-services/corpsales-services/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9d14f6e2"]])

export default __exports__